export default __webpack_public_path__ + "static/media/avatar.6a9901d1.jpg";